import {defineStore} from 'pinia'
import {FilterMatchMode} from "primevue/api";
import _ from "lodash";
import {useDevicesStore} from "@/stores/devices.js";
import {getFirstPage, onFilter, onPage, onRowsUpdate, onSearch, onSort} from "@/stores/_helpers.js";

export const useDevicesIndexPageStore = defineStore('devicesIndexPage', {
    state: () => ({
        data: undefined,
        filters: null,
        totalRecords: 0,
        loading: true,
        requiresUpdateStatuses: [
            {name: 'Requires Update', value: 1},
            {name: 'Updated', value: 0},
        ],
        params: {
            per_page: 20,
            page: 1,
            include: [
                'deviceType',
                'deviceModel',
                'deviceRevision',
                'currentFirmware',
                'targetFirmware',
                'company',
            ],
            filter: {
                search: null
            }
        },
        pages: [
            10,
            20,
            50,
            100,
        ]
    }),
    getters: {
        getDevices: (state) => {
            return state.data?.data;
        },
        getFirstPage: (state) => {
            return getFirstPage(state.params)
        }
    },
    actions: {
        initFilters() {
            this.filters = {
                device_model_ids: {value: null, matchMode: FilterMatchMode.IN},
                device_type_ids: {value: null, matchMode: FilterMatchMode.IN},
                company_ids: {value: null, matchMode: FilterMatchMode.IN},
                device_revision_ids: {value: null, matchMode: FilterMatchMode.IN},
                requires_updates: {value: null, matchMode: FilterMatchMode.IN},
            };
        },
        onPage($event) {
            onPage($event, this.params);
            this.loadData();
        },
        onSort($event) {
            onSort($event, this.params);
            this.loadData();
        },
        onRowsUpdate(rowCount) {
            onRowsUpdate(rowCount, this.params);
        },
        onFilter($event) {
            onFilter($event, this.params);
            this.loadData();
        },
        onSearch: _.debounce(function () {
                onSearch(this.params)
                this.loadData();
            },
            500
        ),
        async loadData() {
            const devicesStore = useDevicesStore();
            this.loading = true;
            this.data = await devicesStore.indexDevices(this.params)
            this.totalRecords = this.data.total;
            this.loading = false;
        }
    },
});
